angular.module('st')
    .controller('crewardsStatusController', [
        '$rootScope','$scope','$http',
        function ($rootScope, $scope, $http) {
            console.log('signing user out');
            $http.get("/rpc/membership/logout")
                .then(function (data) {
                    console.log('user signed out', data);
                    if (data.data.Success == true) {
                        //window.location.reload();
                    };
            });            
        }
    ]);